import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../apis/baseQuery';

export type { StaticPage } from './model';
export type { StaticPageListRequest } from './model';
export type { StaticPageListResponse, StaticPageListMeta } from './model';
export type { StaticPageDetail, StaticPageDetailResponse } from './model';

import type { StaticPageDetailResponse } from './model';

export interface UpdateStaticPagePayload {
  pageId: string;
  pageName: string;
  content: string;
  status?: string;
}

export const staticPagesApi = createApi({
  reducerPath: 'staticPagesApi',
  tagTypes: ['StaticPages'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getStaticPageDetail: builder.query<StaticPageDetailResponse, string>({
      query: (id) => ({
        url: `api/v1/static-page/detail/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _err, id) => [{ type: 'StaticPages', id }],
    }),
    updateStaticPage: builder.mutation<
      { success: boolean; message: string },
      UpdateStaticPagePayload
    >({
      query: (payload) => ({
        url: 'api/v1/static-page/edit',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['StaticPages'],
    }),
  }),
});

export const { useGetStaticPageDetailQuery, useUpdateStaticPageMutation } =
  staticPagesApi;
